import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

const SPLIT = 'split';
const KEEP = 'keep';

const productLabel = (count) => `${count} ${count === 1 ? 'product' : 'products'}`;

/**
 * Asks whether the CRM deals an order covers only part of should be split.
 * `onDecide` gets the ids of the deals to split; `onCancel` means the order action should not go ahead.
 */
const DealSplitModal = ({ deals, onDecide, onCancel }) => {
	const [choices, setChoices] = useState({});
	const isSingleDeal = deals.length === 1;
	const isEveryDealChosen = deals.every((deal) => choices[deal.dealId]);

	const decide = (finalChoices) => {
		onDecide(deals.filter((deal) => finalChoices[deal.dealId] === SPLIT).map((deal) => deal.dealId));
	};

	const choose = (dealId, choice) => {
		const nextChoices = { ...choices, [dealId]: choice };
		if (isSingleDeal) {
			decide(nextChoices);
			return;
		}
		setChoices(nextChoices);
	};

	return (
		<Modal show={true} onHide={onCancel} backdrop="static" centered>
			<div className="common-popup shadow-24dp">
				<Modal.Header closeButton>
					<h3 className="semibold-16 mb-0">
						{isSingleDeal ? 'Split this deal?' : 'Split these deals?'}
					</h3>
				</Modal.Header>
				<Modal.Body>
					<div className="common-popup-body">
						{deals.map((deal) => (
							<div key={deal.dealId} className="mb-3">
								<p className="regular-14 mb-1">
									This order covers {deal.orderedProductCount} of{' '}
									{productLabel(deal.orderedProductCount + deal.remainingProductCount)} in
									deal <span className="semibold-14">{deal.dealName}</span>.
								</p>
								<p className="regular-14 gray_dark_02 mb-2">
									Split it if you expect more orders for the other{' '}
									{productLabel(deal.remainingProductCount)}: the ordered products move to{' '}
									{deal.splitDealName ? (
										<span className="semibold-14">{deal.splitDealName}</span>
									) : (
										'a new PO Received deal'
									)}{' '}
									and the rest stay in this deal. Otherwise the whole deal moves to PO
									Received.
								</p>
								<div className="text-right">
									<button
										className={`button size32 ${choices[deal.dealId] === KEEP ? '' : 'outline'}`}
										onClick={() => choose(deal.dealId, KEEP)}
									>
										Keep as one deal
									</button>
									<button
										className={`button size32 ml-2 ${choices[deal.dealId] === SPLIT ? '' : 'outline'}`}
										onClick={() => choose(deal.dealId, SPLIT)}
									>
										Split deal
									</button>
								</div>
							</div>
						))}
					</div>
				</Modal.Body>
				{!isSingleDeal && (
					<Modal.Footer>
						<div className="footer-buttons text-right">
							<button className="button outline size32" onClick={onCancel}>
								Cancel
							</button>
							<button
								className="button size32 ml-2"
								disabled={!isEveryDealChosen}
								onClick={() => decide(choices)}
							>
								Confirm
							</button>
						</div>
					</Modal.Footer>
				)}
			</div>
		</Modal>
	);
};

export default DealSplitModal;
